import {
  FLAVOR_TEXT,
  ICON_ALT,
  MAIN_IMAGE_ALT,
  WEBSITE_EMAIL,
  WEBSITE_EMAIL_LINK,
  WEBSITE_TITLE_A,
  WEBSITE_TITLE_B,
} from './constants';
import BACKGROUND_IMAGE from './assets/animated-shape.svg';
import MAIN_IMAGE from './assets/rachel-in-studio.jpg';
import ICON_EMAIL from './assets/mail-bulk-solid.svg';

function App() {
  return (
    <div className="flex justify-center items-center h-screen w-screen flex-col sm:flex-row bg-gradient-to-r from-red-900 to-red-500 via-red-600 overflow-hidden p-4">
      <div
        className="absolute w-screen h-screen bg-cover"
        style={{ backgroundImage: `url(${BACKGROUND_IMAGE})` }}
      ></div>
      <header className="flex flex-col gap-y-6 items-center relative z-10 translate-y-12 sm:translate-y-0">
        <div className="flex flex-col">
          <span className="font-raleway uppercase text-2xl tracking-widest hover:translate-x-1 transition-all text-black opacity-80 hover:opacity-100">
            {FLAVOR_TEXT}
          </span>
          <span className="font-raleway uppercase font-black text-gray-100 opacity-80 hover:opacity-100 text-6xl italic pr-10 hover:-translate-x-1 transition-all">
            {WEBSITE_TITLE_A}
          </span>
          <span className="font-raleway uppercase font-black text-gray-100 opacity-80 hover:opacity-100 text-6xl italic pl-10 hover:translate-x-1 transition-all">
            {WEBSITE_TITLE_B}
          </span>
        </div>
        <div className="flex gap-x-2 text-center rounded-full bg-gray-100 bg-opacity-80 hover:bg-opacity-100 py-3 px-6 hover:shadow-2xl text-gray-900 align-middle -translate-y-2 hover:translate-y-0 transition-all">
          <img
            src={ICON_EMAIL}
            alt={ICON_ALT}
            className="w-8 h-8 fill-gray-900"
          />
          <a
            href={WEBSITE_EMAIL_LINK}
            className="text-xl font-arvo"
            target="_blank"
            rel="noreferrer"
          >
            {WEBSITE_EMAIL}
          </a>
        </div>
      </header>
      <img
        src={MAIN_IMAGE}
        alt={MAIN_IMAGE_ALT}
        className="h-full max-h-[530px] sm:max-h-[640px] rotate-12 hover:rotate-[11deg] transition-all shadow-2xl"
      />
    </div>
  );
}

export default App;
